document.addEventListener('DOMContentLoaded', function() {
  function attachBooqableCart() {
    // On sélectionne le bouton panier du menu Shopify
    const cartButton = document.querySelector('a[href="/cart"], a[href^="/cart"]');
    if (!cartButton) return;

    cartButton.addEventListener('click', function(e) {
      // Si Booqable est prêt, on ouvre le mini-panier
      if (window.Booqable && Booqable.cart) {
        e.preventDefault();  // On empêche seulement la redirection Shopify
        Booqable.cart.open();
      }
      // Sinon on ne fait rien, on laisse le bouton agir normalement
    });
  }

  // On attend que le widget Booqable soit chargé
  if (window.Booqable) {
    if (Booqable.cart) {
      attachBooqableCart();
    } else {
      Booqable.on('ready', attachBooqableCart);
    }
  } else {
    console.log("Booqable non chargé sur cette page.");
  }
});


